import {useCallback} from 'react'
import useShowOverlay from 'hooks/useShowOverlay/useShowOverlay'
import {OverlayType} from 'modules/overlay/types'

export const useCashbackInfoClick = () => {
  const showOverlay = useShowOverlay()

  return useCallback(
    (value: number) => {
      showOverlay({
        type: OverlayType.CashbackInfo,
        params: {value}
      })
    },
    [showOverlay]
  )
}
